import React from "react";
import { Link } from "react-router";
import { getDeep } from "../../functions";
import { usePermissions } from "../../utils/auth";

export default function masterdataIndexlinks({ buttons }) {
    let links = [];
    let permissions = usePermissions();

    if (buttons) {
        links = buttons.map((button) => (
            <Link key={`button-${button.title}`} to={button.link} className={button.classname}>
                {button.title}
            </Link>
        ));
    } else {
        links = <div className="section-buttons">{links}</div>;
    }

    return (
        <div>
            <div className="section-top has-subheader-index col-12">
                <h1>Stamgegevens</h1>

                {links}

                <div className="subheader-index">
                    {getDeep(permissions, "endterm", "read") ? (
                        <Link to="/masterdata/endterms" activeClassName="active">
                            Eindtermen
                        </Link>
                    ) : (
                        false
                    )}
                    {getDeep(permissions, "competence", "read") ? (
                        <Link to="/masterdata/competences" activeClassName="active">
                            Competenties
                        </Link>
                    ) : (
                        false
                    )}
                    {getDeep(permissions, "measurementbundle", "read") ? (
                        <Link to="/masterdata/measurementbundles" activeClassName="active">
                            Toetsbundels
                        </Link>
                    ) : (
                        false
                    )}
                    {getDeep(permissions, "measurement", "read") ? (
                        <Link to="/masterdata/measurements" activeClassName="active">
                            Toetsingen
                        </Link>
                    ) : (
                        false
                    )}
                </div>
            </div>
        </div>
    );
}
